/**
 * 客户端实时数据更新工具
 *
 * 由于 CORS 限制,客户端浏览器无法直接 fetch ssqzj.com / 17500.cn 等数据源
 * 数据更新策略:
 *   1. 部署时:运行 `node scripts/fetch-latest.cjs` 拉取最新 → build → deploy
 *   2. 运行时:用户点"立即更新" → 通过 CORS proxy 尝试拉取(成功率低)
 *
 * CORS proxies 列表(成功率随时间变化):
 */
const CORS_PROXIES = [
  'https://api.allorigins.win/get?url=',
  'https://api.codetabs.com/v1/proxy?quest=',
];

const TARGET_URL = 'https://www.ssqzj.com/3d/';

async function fetchWithProxy(url) {
  let lastError;
  for (const proxy of CORS_PROXIES) {
    try {
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), 12000);
      const res = await fetch(proxy + encodeURIComponent(url), {
        headers: { 'Accept': 'application/json,text/html' },
        signal: ctrl.signal,
      });
      clearTimeout(timer);
      if (res.ok) {
        let text = await res.text();
        // allorigins 返回 JSON,提取 contents
        try {
          const j = JSON.parse(text);
          if (j.contents) text = j.contents;
        } catch {}
        if (text && text.length > 1000) return text;
      }
    } catch (e) {
      lastError = e;
    }
  }
  throw new Error('CORS proxy 失败(常见原因:代理被封 / 网络限制): ' + (lastError?.message || ''));
}

function parseResults(html) {
  const results = [];
  const re = /<td>(\d{7})<\/td>\s*<td>(\d{4}-\d{2}-\d{2})<\/td>\s*<td><em>(\d{3})<\/em><\/td>/g;
  let m;
  while ((m = re.exec(html)) !== null) {
    const p = m[1];
    const d = m[2];
    const num = m[3];
    if (parseInt(p) >= 2026001 && parseInt(p) <= 2027000) {
      const a = parseInt(num[0]);
      const b = parseInt(num[1]);
      const c = parseInt(num[2]);
      const sum = a + b + c;
      const span = Math.max(a, b, c) - Math.min(a, b, c);
      const uniq = new Set([a, b, c]);
      const type = uniq.size === 3 ? '组六' : uniq.size === 2 ? '组三' : '豹子';
      results.push({ p, d, a, b, c, sum, span, type });
    }
  }
  return results;
}

export async function fetchLatestData() {
  const html = await fetchWithProxy(TARGET_URL);
  return parseResults(html);
}

